// extracted by mini-css-extract-plugin
module.exports = {"participantList":"ChatParticipants_participantList__3KFfZ","spin360":"ChatParticipants_spin360__29VgX"};